module.exports = __webpack_public_path__ + "img/SearchBySplint-01.6b4c8448.svg";